import { useContext } from 'react';

import { UserContext } from '~/components/providers/UserProvider';
import type { Contest } from '~/domains/contest/domains/services/interfaces/contest.interface';

const useIsContestCommissioner = (contest: Contest) => {
  const { user } = useContext(UserContext);

  return contest?.commissioner?.id === user?.id;
};

export default useIsContestCommissioner;
